import './index.pcss';
import $ from 'jquery';

if ($('.explorer').length) {
    $('main').css('min-height', 'unset');
}